module.exports = __webpack_public_path__ + "dashboard.5efe4613300ea2fff836c4165ea0a9f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/selected/dashboard.svg
// module id = 332
// module chunks = 0